import React from "react";

const SearchIcon: React.FC<{ className?: string; color?: string }> = ({
  className,
  color = "black", // Default color is black
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8611 13.8333L12.8056 10.7777C13.5695 9.66666 14.0555 8.34724 14.0555 6.88891C14.0555 3.27779 11.0694 0.291656 7.45823 0.291656C3.84714 0.291656 0.861023 3.27779 0.861023 6.88891C0.861023 10.5 3.84714 13.4862 7.45823 13.4862C8.91656 13.4862 10.2361 13 11.3472 12.2361L14.4027 15.2917L15.8611 13.8333ZM2.94436 6.95832C2.94436 4.45833 4.95825 2.44444 7.45823 2.44444C9.95823 2.44444 11.9721 4.45833 11.9721 6.95832C11.9721 9.45832 9.95823 11.4722 7.45823 11.4722C4.95825 11.4722 2.94436 9.45832 2.94436 6.95832Z"
      fill={color}
    />
  </svg>
);

export default SearchIcon;
